import {Children} from "react";

export function toArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [v];
}

export function getOptionName(option) {
    return option?.name ?? option?.assetName ?? option?.title ?? "";
}

export function findOptionById(list, id) {
    if (id == null || !list) return undefined;
    for (const item of list) {
        if (String(item.id) === String(id)) return item;
        if (item.children) {
            const found = findOptionById(toArray(item.children), id);
            if (found) return found;
        }
    }
    return undefined;
}

export function findParentInTree(nodes, target) {
    if (!nodes?.length || !target) return null;
    for (const node of nodes) {
        const children = toArray(node.children);
        if (children.some((c) => String(c?.id) === String(target?.id))) return node;
        const found = findParentInTree(children, target);
        if (found) return found;
    }
    return null;
}

export function getParentChainFromTree(codes, item) {
    if (!codes || !item) return [];
    const chain = [];
    let current = item;
    while (current) {
        const p = findParentInTree(codes, current);
        if (!p) break;
        chain.unshift(p);
        current = p;
    }
    return chain;
}

/** breadcrumb 첫 항목은 필드 루트로 라벨과 중복 */
export function getBreadcrumbDisplayChain(parentChain) {
    if (!parentChain?.length) return [];
    return parentChain.slice(1);
}

function hexToRgb(hex) {
    if (!hex) return null;
    let h = hex.trim();
    if (!h.startsWith("#")) return null;
    h = h.slice(1);
    if (h.length === 3 || h.length === 4) {
        h = h.split("").map((c) => c + c).join("");
    }
    if (h.length === 8) h = h.slice(0, 6);
    if (h.length !== 6) return null;
    const n = parseInt(h, 16);
    return {r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255};
}

function relativeLuminance({r, g, b}) {
    const srgb = [r, g, b].map((v) => v / 255).map((c) =>
        (c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4),
    );
    return 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
}

function contrastRatio(l1, l2) {
    const [L1, L2] = l1 >= l2 ? [l1, l2] : [l2, l1];
    return (L1 + 0.05) / (L2 + 0.05);
}

export function pickReadableTextColor(bgHex) {
    const rgb = hexToRgb(bgHex);
    if (!rgb) return "#111827";

    const bgL = relativeLuminance(rgb);
    const cWhite = contrastRatio(bgL, 1);
    const cBlack = contrastRatio(bgL, relativeLuminance(hexToRgb("#111827")));

    if (cWhite >= 3) return "#ffffff";
    return cBlack >= cWhite ? "#111827" : "#ffffff";
}

export function hasExtendedPanel(children, useMultiSearch) {
    if (useMultiSearch) return true;
    if (!children) return false;
    return Children.count(children) > 0;
}
